import type { BuildOrganizationVisibleMicroAppsPathParams } from '../types';

const buildOrganizationVisibleMicroAppsPath = ({
    organizationId,
}: BuildOrganizationVisibleMicroAppsPathParams): string => `/organizations/${organizationId}/apps`;

export default buildOrganizationVisibleMicroAppsPath;
